'use es6';

import { APP_STARTED } from './ActionTypes';
import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
export const startApp = () => dispatch => {
  dispatch({
    type: APP_STARTED,
    payload: {
      trackingParams: getParsedTrackingParams()
    }
  });
};